import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { produceUserContextRouteQueryStringEpics } from '@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { matchesRootPathname } from '@ane/exp-data/lib/routes/Route.utils';
import { dataSourceSchemaActionTypes, dataSourceSchemaLoadingAction, dataSourceSchemaLoadedAction, } from '../ducks/DataSourceDetailSchema.ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import DataSourceResource from '../../../DataSource.resource';
import { EXP_QUERY_STRINGS } from '@ane/core/lib/constants/QueryString.constants';
import { DataSourceDetailConstants, setUserContextFunc, } from '../ducks/DataSourceDetailContext.ducks';
import { DataSourceRouteUtils } from '@ane/exp-data/lib/routes/DataSourceRoute.utils';
import { DataSourceDetailUserContextParam } from '../../../../models/DataSourceDetailUserContextParams';
export const LoadDataSourceSchemaArgs = {
    filterOnType: dataSourceSchemaActionTypes.LOAD,
    loadResource: (payload, state) => {
        return DataSourceResource.getDataSourceSchema(payload.workspaceId, payload.dataSourceName);
    },
    loadingAction: dataSourceSchemaLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(dataSourceSchemaLoadedAction(payload, result));
    },
};
export const loadDataSourceSchemaArgs = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(LoadDataSourceSchemaArgs);
export const provideDataSourceSchemaEpics = (history) => {
    // Adding this epic fully connects the Route URL and the Store for the given "UserContextSpec"
    // When the URL is set, the spec will be used to call the correct actions
    // When the user context is set the URL will be updated.
    const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(DataSourceDetailUserContextParam, setUserContextFunc, DataSourceDetailConstants.SET_PARTIAL_USER_CONTEXT, DataSourceDetailConstants.SET_USER_CONTEXT, (store) => store.dataSourceManagementModule.dataSourceDetailState.userContext, history, (pathname) => {
        return matchesRootPathname(pathname, DataSourceRouteUtils.routes.view.path());
    }, EXP_QUERY_STRINGS);
    const dataSourceSchemaEpics = combineEpics(loadDataSourceSchemaArgs, ...Object.values(setUserContextFromRouteQueryString));
    return dataSourceSchemaEpics;
};

//# sourceMappingURL=DataSourceSchemaEpic.js.map
